import { render, staticRenderFns } from "./CheckupDetail.vue?vue&type=template&id=189184f0&scoped=true"
import script from "./CheckupDetail.vue?vue&type=script&lang=js"
export * from "./CheckupDetail.vue?vue&type=script&lang=js"
import style0 from "./CheckupDetail.vue?vue&type=style&index=0&id=189184f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189184f0",
  null
  
)

export default component.exports